// @flow
import * as React from 'react';
import {Route, Redirect, Switch, useHistory, useParams, useRouteMatch, useLocation} from 'react-router-dom';
import * as VRUtils from 'utils/vrUtils';
import Guide from './Guide';
import Countdown from './Countdown';
import HeadsUpDisplay from './HeadsUpDisplay';
import DrivingResult from './DrivingResult';
import DrivingZeroback from './DrivingZeroback';
import GTModeGuide from './GTModeGuide';
import MaxSpeed from './MaxSpeed';
import Map from '../Map';
import ModalIndex from './ModalIndexA';
import ModalExteriorColor from 'components/ModalExteriorColor';
import {useSessionDispatch} from 'components/Session';
import Loading from '../../Loading';
import Disclaimer from 'components/Disclaimer'
import * as AudioUtils from 'utils/audioUtils';
import SoundToggleButton from 'components/SoundToggleButton';
//import {useLayoutState} from 'components/Layout';
import Settings from 'config/Settings';
import {isTouch} from 'components/Responsive';


function useQuery() {
  return new URLSearchParams(useLocation().search);
}


const DRIVING_MODE = {
  GUIDE: 0,
  PLAY: 1,
  COMPLETED: 2,
  TRYAGAIN: 3,
  GTMODE_GUIDE: 4,
  ZEROBACK: 5,
  ZEROBACK_COMPLETED: 6,
  ZEROBACK_TRYAGAIN: 7,
  MAX_SPEED: 8,
  MAP: 9,

  PLAY_URL: 'play',
  GTMODE_GUIDE_URL: 'gtmode-guide',
  ZEROBACK_URL: 'acceleration',
  MAX_SPEED_URL: 'max-speed',
  MAP_URL: 'map',
};

function getEnumKeys(obj) {

  var result = [];
  for (var key in obj) {
    result.push(key);
  }
  return result;
}

type Props = {
};

const drivingModeKeys = getEnumKeys(DRIVING_MODE);

export default function CourseA(props: Props): React.Element<any> {
  const {path, url} = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${url}/play`} />
      </Route>
      <Route path={`${url}/:mode`} children={<DrivingMode />} />
      <Redirect to={path} />
    </Switch>
  );
}

function getInitialDrivingMode(mode: string) {
  const devmode = process.env.NODE_ENV === 'development' && window.location.search.indexOf('devmode=true') >= 0;
  switch (mode) {
    case DRIVING_MODE.PLAY_URL: return devmode ? DRIVING_MODE.PLAY : DRIVING_MODE.GUIDE;
    case DRIVING_MODE.GTMODE_GUIDE_URL: return DRIVING_MODE.GTMODE_GUIDE;
    case DRIVING_MODE.ZEROBACK_URL: return DRIVING_MODE.ZEROBACK;
    case DRIVING_MODE.MAX_SPEED_URL: return DRIVING_MODE.MAX_SPEED;
    case DRIVING_MODE.MAP_URL: return DRIVING_MODE.MAP;
    default: return DRIVING_MODE.GUIDE;
  }
}

function syncUIPositions() {
  var GTItem1 = document.getElementById("GTItem1");
  var GTItem2 = document.getElementById("GTItem2");
  var GTItem3 = document.getElementById("GTItem3");
  var GTItem4 = document.getElementById("GTItem4");
  var EcoItem = document.getElementById("EcoItem");
  var pc = window.pc;
  var vrCanvas = VRUtils.getVRCanvas();
  var width = (vrCanvas?.offsetWidth ?? 1);
  var height = (vrCanvas?.offsetHeight ?? 1);
  function getUV(e) {
    var pos = e.getBoundingClientRect();
    var u = (pos.left + pos.width * 0.5) / width;
    var v = (pos.top + pos.height * 0.5) / height;
    return new pc.Vec2(u, v);
  }

    
  if (GTItem1 != null) {
    VRUtils.fireVREvent("fx:item:gt1SetUV", getUV(GTItem1) );
  }
  if (GTItem2 != null) {
    VRUtils.fireVREvent("fx:item:gt2SetUV", getUV(GTItem2) );
  }
  if (GTItem3 != null) {
    VRUtils.fireVREvent("fx:item:gt3SetUV", getUV(GTItem3) );
  }
  if (GTItem4 != null) {
    VRUtils.fireVREvent("fx:item:gt4SetUV", getUV(GTItem4) );
  }
  if (EcoItem != null) {
    var uv = getUV(EcoItem);
    VRUtils.fireVREvent("fx:item:ecoSetUV", uv );
  }

}
function callSyncUIPositions() {
  setTimeout(syncUIPositions, 200);
  setTimeout(syncUIPositions, 400);
  setTimeout(syncUIPositions, 1600);
}

window.syncUIPositions = syncUIPositions;


export function DrivingMode(props: Props): React.Element<any> {
  const history = useHistory();
  const { mode } = useParams();
  const currentDrivingMode = React.useRef<number>(-1);
  const prevDrivingMode = React.useRef<number>(-1);
  const loaded3d = React.useRef<null | string>(null);
  const [drivingMode, setDrivingMode] = React.useState(getInitialDrivingMode(mode));
  const [isLoading, setIsLoading] = React.useState(false);

  const [countdown, setCountdown] = React.useState(-1)
  const [showModalIndexColorButton, setShowModalIndexColorButton] = React.useState(false);
  const [openModalIndex, setOpenModalIndex] = React.useState(false);
  const [openModalExteriorColor, setOpenModalExteriorColor] = React.useState(false);
  const [GTItemArray, setGTItemArray] = React.useState([false, false, false, false]);

  const [ecoItemCount, setEcoItemCount] = React.useState(0);

  const extraCanvasRef = React.useRef(document.getElementById("extraCanvas"));
  const [imageCaptured, setImageCaptured] = React.useState(false);
  //const [capturedData, setCapturedData] = React.useState("");
  const sessionDispatch = useSessionDispatch();
  const [disclaimerPopupKey, setDisclaimerPopupKey] = React.useState("");
  //const layoutState = useLayoutState();

  const guide = useQuery().get("guide");
  const guideNo = React.useMemo(() => guide != null ? parseInt(guide) : null, [guide]);
  React.useEffect(() => {
    if (drivingMode !== DRIVING_MODE.GUIDE && guideNo != null) {
      setDrivingMode(DRIVING_MODE.GUIDE);
    }
  }, [guideNo, drivingMode]);


  
  if (currentDrivingMode.current === -1) {
    currentDrivingMode.current = drivingMode;
  }
  if (drivingMode !== currentDrivingMode.current ) {
    prevDrivingMode.current = currentDrivingMode.current;
    currentDrivingMode.current = drivingMode;

    console.log("drivingMode:", drivingModeKeys[prevDrivingMode.current], '->', drivingModeKeys[drivingMode]);
  }

  const handleOpenModalIndex = React.useCallback((showColorButton?: boolean) => {
    if (showColorButton === true) {
      setShowModalIndexColorButton(true);
    }
    setOpenModalIndex(true);
    VRUtils.ready(()=>{
      window.SceneController.pause("popup");
    });
    
  }, []);


  const handleCloseModalIndex = React.useCallback(() => {
    setOpenModalIndex(false);
    setShowModalIndexColorButton(false);
    VRUtils.ready(()=>{
      window.SceneController.play("popup");
    });
    
  }, []);

  const handleOpenModalExteriorColor = React.useCallback(() => {
    setOpenModalExteriorColor(true);
    handleCloseModalIndex();
    window.tagManager.indexPopChangeExteriorColorLinkClick();
    VRUtils.ready(()=>{
      window.SceneController.pause("popup-color");  
    });
    
  }, [handleCloseModalIndex])

  const handleCloseModalExteriorColor = React.useCallback(() => {
    setOpenModalExteriorColor(false);
    VRUtils.ready(()=>{
       window.SceneController.play("popup-color");
    });
    
  }, []);

  const handleRetry = React.useCallback(() => {
    console.log("AA:in handleRetry");
    window.tagManager.drivingZoneCourseAGamePlayTryAgainEvent();
    setCountdown(3);
    setDrivingMode(DRIVING_MODE.PLAY);
  }, [])
  const minTime = process.env.NODE_ENV === 'development' ? 310 : 310;
  const maxTime = process.env.NODE_ENV === 'development' ? 320 : 320;

  const handleStartZeroback = React.useCallback(() => {
      setImageCaptured(false);
      VRUtils.fireVREvent('startRace');
      VRUtils.ready(()=>{
        window.SceneController.play("dragrace");
      });
      
      VRUtils.setResolutionMin();
  }, []);

  window.VRUtils = VRUtils;

  React.useEffect(()=>{
    switch(prevDrivingMode.current) {
      case DRIVING_MODE.GTMODE_GUIDE:
        VRUtils.playGTModeGuide()
      break;
      default:
      break;
    }

    // if (drivingMode == DRIVING_MODE.GUIDE) {
    //   VRUtils.pause("drivingModeGuide");
    // } else {
    //   VRUtils.play("drivingModeGuide");
    // }

    if (VRUtils.getSceneName() === "course_a") {
      if (drivingMode !== DRIVING_MODE.PLAY && 
        drivingMode !== DRIVING_MODE.COMPLETED && 
        drivingMode !== DRIVING_MODE.TRYAGAIN ) {
        VRUtils.pause("course_a_pause");
      } else {
        VRUtils.play("course_a_pause");
      }
    }
    if (VRUtils.getSceneName() === "course_a2") {
      if (drivingMode !== DRIVING_MODE.ZEROBACK && 
        drivingMode !== DRIVING_MODE.ZEROBACK_COMPLETED && 
        drivingMode !== DRIVING_MODE.ZEROBACK_TRYAGAIN ) {
        VRUtils.pause("course_a2_pause");
      } else {
        VRUtils.play("course_a2_pause");
      }
    }

    switch(drivingMode) {
      case DRIVING_MODE.GUIDE:
      
      break;
      case DRIVING_MODE.PLAY:
      AudioUtils.playBGM_racing();
      break;
      case DRIVING_MODE.COMPLETED:
      AudioUtils.playBGM_UI();
      break;
      case DRIVING_MODE.TRYAGAIN:
      AudioUtils.playBGM_UI();
      break;
      case DRIVING_MODE.GTMODE_GUIDE:
      AudioUtils.playBGM_UI();
      break;
      case DRIVING_MODE.ZEROBACK:
      AudioUtils.playBGM_zero100();
      break;
      case DRIVING_MODE.ZEROBACK_COMPLETED:
      AudioUtils.playBGM_zero100();
      break;
      case DRIVING_MODE.ZEROBACK_TRYAGAIN:
      AudioUtils.playBGM_zero100();
      break;
      case DRIVING_MODE.MAX_SPEED:
      AudioUtils.stopBGM();
      break;
      case DRIVING_MODE.MAP:
      AudioUtils.playBGM_UI();
      break;
      default:
      break;
    }
    switch(drivingMode) {
      case DRIVING_MODE.GTMODE_GUIDE:
        VRUtils.pauseGTModeGuide();
      break;

      case DRIVING_MODE.ZEROBACK:
        setImageCaptured(false);
        break;
      case DRIVING_MODE.ZEROBACK_COMPLETED:
      case DRIVING_MODE.ZEROBACK_TRYAGAIN:
      break;

      default:
      break;
    }

    switch(drivingMode) {
      case DRIVING_MODE.PLAY:
      window.tagManager.drivingZoneCourseAGamePlayPage();
      break;
      case DRIVING_MODE.COMPLETED:
      case DRIVING_MODE.TRYAGAIN:
      window.tagManager.drivingZoneCourseAGamePlayResultPage();
      break;
      case DRIVING_MODE.GTMODE_GUIDE:
      window.tagManager.drivingZoneCourseAActivateGTModePage();
      break;
      case DRIVING_MODE.ZEROBACK:
      window.tagManager.drivingZoneCourseAAccelerationPage();
      break;
      case DRIVING_MODE.ZEROBACK_COMPLETED:
      window.tagManager.drivingZoneCourseAAccelerationResultPage();
      break;
      case DRIVING_MODE.ZEROBACK_TRYAGAIN:
      window.tagManager.drivingZoneCourseAAccelerationResultPage();
      break;
      case DRIVING_MODE.MAX_SPEED:
      window.tagManager.drivingZoneCourseAMaxSpeedPage();
      break;
      case DRIVING_MODE.MAP:
      
      break;

      default:
      break;
    }
    
  }, [drivingMode]);

  React.useEffect(()=>{

    function log_race2_finished() {
      const time = window.dragRaceStopTime || 700;
      if ((time >= minTime && time < maxTime)) {
        window.targetFinishDrageRaceTime = time / 100;
        window.devCourseA2TargetFinishDrageRaceTime = "perect "+window.targetFinishDrageRaceTime;
        setDrivingMode(DRIVING_MODE.ZEROBACK_COMPLETED);

      }
      else {
        if (time < minTime) {
          window.targetFinishDrageRaceTime = time / 100 - 0.05;
        } else {
          window.targetFinishDrageRaceTime = time / 100 + 0.05;
        }
        window.devCourseA2TargetFinishDrageRaceTime = "perect "+window.targetFinishDrageRaceTime;
        setDrivingMode(DRIVING_MODE.ZEROBACK_TRYAGAIN)
      }
      window.Velocity(extraCanvasRef.current, "stop");
      const duration = 0.5;
      window.showOverlayCanvasEffect(duration, "effectFadeIn");
      setTimeout(function(){
        VRUtils.setResolutionMax();
        if (window.dragRaceStopTime != null) {
          VRUtils.fireVREvent("raceTime", window.targetFinishDrageRaceTime );
        }
      }, duration * 500);
      
      if (extraCanvasRef.current?.style) {
        extraCanvasRef.current.style.opacity = "0.0";
      }
      window.Velocity(extraCanvasRef.current, {opacity:[1.0, 0.0]}, {duration:500});
    }

    function log_race2_intro1Completed() {
      console.log("log_race2_intro1Completed");
    }

    VRUtils.addVREventListener("race2:finished", log_race2_finished);
    VRUtils.addVREventListener("race2:intro1Completed", log_race2_intro1Completed);
    
    return ()=>{
      VRUtils.removeVREventListener("race2:finished", log_race2_finished);
      VRUtils.removeVREventListener("race2:intro1Completed", log_race2_intro1Completed);
    };
  }, [minTime, maxTime]);

  const handleStopZeroback = React.useCallback((time: number) => {
    window.showOverlayEffect(0.1);
    setImageCaptured(true);
    window.dragRaceStopTime = time;
    if ((time >= minTime && time < maxTime)) {
      
    }



  }, [minTime, maxTime]);

  const handleRetryZeroback = React.useCallback(() => {
    setDrivingMode(DRIVING_MODE.ZEROBACK);
    VRUtils.fireVREvent('prepareRace');
    VRUtils.ready(()=>{
      window.SceneController.play("dragrace");
    });
    
    VRUtils.setResolutionMax();

  }, [])

  const setDrivingModeUrl = React.useCallback((index: number) => {
    switch (index) {
      case DRIVING_MODE.GUIDE: history.push(`/driving-zone/course-a/${DRIVING_MODE.PLAY_URL}`); break;
      case DRIVING_MODE.GTMODE_GUIDE: history.push(`/driving-zone/course-a/${DRIVING_MODE.GTMODE_GUIDE_URL}`); break;
      case DRIVING_MODE.ZEROBACK: history.push(`/driving-zone/course-a/${DRIVING_MODE.ZEROBACK_URL}`); break;
      case DRIVING_MODE.MAX_SPEED: history.push(`/driving-zone/course-a/${DRIVING_MODE.MAX_SPEED_URL}`); break;
      case DRIVING_MODE.MAP: history.push(`/driving-zone/course-a/${DRIVING_MODE.MAP_URL}`); break;
      default: setDrivingMode(index); break;
    }
  }, [history]);

  function onElementFocused() {
    if (document.activeElement != null) {
      document.activeElement?.blur();
    }
  }

  React.useEffect(()=>{
    window.addEventListener("resize", callSyncUIPositions);
    document.addEventListener("focus", onElementFocused, true);
    return ()=>{
      window.removeEventListener("resize", callSyncUIPositions);
      document.removeEventListener("focus", onElementFocused, true);
    };
  }, []);


  React.useEffect(() => {
    function race_start() {
      VRUtils.setVRMaxPixelRatio(1.0);
      VRUtils.setVRMinPixelRatio(1.0);
    }

    function race_item(items) {
      const gtItems = items.gt?.reduce(
        (prev, curr) => {
          prev[curr - 1] = true;
          return prev;
        },
        [false, false, false, false]
      );
      setGTItemArray(gtItems);
      setEcoItemCount(items.eco?.length ?? 0);
    }

    function race_finished(succeeded, acquiredItems) {
      console.log('race_finished', succeeded);
      VRUtils.setVRMaxPixelRatio(window.devicePixelRatio);
      VRUtils.setVRMinPixelRatio(window.devicePixelRatio);
      setCountdown(4);
      VRUtils.setResolutionMax();
      setTimeout(() => {
        setCountdown(-1);
        if (succeeded) {
          setDrivingMode(DRIVING_MODE.COMPLETED);
        } else {
          setDrivingMode(DRIVING_MODE.TRYAGAIN);
        }
      }, 2000);
    }

    function log_race_prepare() {
      console.log("race:prepare");
      VRUtils.setAverageFPS(false);
      VRUtils.setResolutionMax();
    }
    function log_race_start() {
      console.log("race:start");
      VRUtils.setAverageFPS(true);
      setCountdown(0);
      VRUtils.setResolutionMin();
      callSyncUIPositions();
      setTimeout(() => setCountdown(-1), 1000);
    }
    function log_race_finished() {
      VRUtils.setAverageFPS(true);
      console.log("race:finished");
    }
    function log_race_intro3() {
      console.log("race:intro 3");
      setCountdown(3)
    }
    function log_race_intro2() {
      console.log("race:intro 2");
      setCountdown(2)
    }
    function log_race_intro1() {
       console.log("race:intro 1");
       setCountdown(1)
    }
    var sceneSetup = {
      select_color : {
        assets : ["car0"],
        init : function(drivingMode){
          VRUtils.ready(()=>{
            window.SceneController.play("popup");
          });
          
        },
        deinit : function(){},
      },
      course_a : {
        assets : ["car0"],
        init : function(drivingMode) {

          VRUtils.ready(()=>{
            window.SceneController.pause("guide");
          });
          

          VRUtils.addVREventListener('race:start', race_start);
          VRUtils.addVREventListener('race:item', race_item);
          VRUtils.addVREventListener('race:finished', race_finished);
          
          console.log("vrutils_test, init");

          VRUtils.addVREventListener('race:prepare', log_race_prepare);
          VRUtils.addVREventListener('race:start', log_race_start);
          VRUtils.addVREventListener('race:intro3', log_race_intro3);
          VRUtils.addVREventListener('race:intro2', log_race_intro2);
          VRUtils.addVREventListener('race:intro1', log_race_intro1);
          VRUtils.addVREventListener('race:finished', log_race_finished);
          
          if (drivingMode === DRIVING_MODE.PLAY) {
            console.log("loading, calling course_a setStartRace, drivingMode=", drivingModeKeys[drivingMode]);
            VRUtils.fireStartRace();
          } else {
            //console.error("loading, skipped calling course_a setStartRace, drivingMode=", drivingModeKeys[drivingMode]);
          }
        },
        deinit : function() {

          console.log("vrutils_test, deinit");

          VRUtils.ready(()=>{
            window.SceneController.play("guide");
          });
          
          VRUtils.removeVREventListener('race:start', race_start);
          VRUtils.removeVREventListener('race:item', race_item);
          VRUtils.removeVREventListener('race:finished', race_finished);

          VRUtils.removeVREventListener('race:prepare', log_race_prepare);
          VRUtils.removeVREventListener('race:start', log_race_start);
          VRUtils.removeVREventListener('race:intro3', log_race_intro3);
          VRUtils.removeVREventListener('race:intro2', log_race_intro2);
          VRUtils.removeVREventListener('race:intro1', log_race_intro1);
          VRUtils.removeVREventListener('race:finished', log_race_finished);

        }
      },
      course_a2 : {
        assets : ["car0"],
        init : function(drivingMode) {
          VRUtils.setResolutionMax();
        },
        deinit : function() {
          VRUtils.ready(()=>{
            window.SceneController.play("dragrace");
          });
          
        }
      },

    };

    function getSceneNameFromMode(mode) {
      switch(drivingMode) {
        case DRIVING_MODE.GUIDE:
        case DRIVING_MODE.PLAY:
        case DRIVING_MODE.COMPLETED:
        case DRIVING_MODE.TRYAGAIN:
        return "course_a";
        
        case DRIVING_MODE.GTMODE_GUIDE:
        case DRIVING_MODE.ZEROBACK:
        case DRIVING_MODE.ZEROBACK_COMPLETED:
        case DRIVING_MODE.ZEROBACK_TRYAGAIN:
        return "course_a2";
        default: return null;
      }

    }

    const loadname = getSceneNameFromMode(drivingMode);
    console.log("loading for drivingMode:", drivingMode, "loaded3d.current:", loaded3d.current, "loading, loadname:", loadname);

    if (loadname != null && loadname !== loaded3d.current) {
      const s = sceneSetup[loadname];
      loaded3d.current = loadname;
      setIsLoading(true);
      VRUtils.loadScene(loadname, s.assets, () => {

        console.log("loading done:", loadname);
        s.init(currentDrivingMode.current);
        setIsLoading(false);
      });
    }
    if (drivingMode === DRIVING_MODE.PLAY) {
      console.log("loading, calling fireStartRace, drivingMode=", drivingModeKeys[drivingMode]);
      VRUtils.fireStartRace();
    }

    return function () {
      const loadname = getSceneNameFromMode(drivingMode);
      if (loaded3d.current !== loadname && loadname !== null) {
        console.log("loading deinit: loaded3d.current=", loaded3d.current);
        const s = sceneSetup[loadname];
        VRUtils.unloadScene(s.deinit());
        loaded3d.current = null;
      }
    };
  }, [drivingMode]);

  React.useEffect(() => {
    setDrivingMode(getInitialDrivingMode(mode));
    sessionDispatch({type: 'APPLY_EXTERIOR_COLOR', data: null});
  }, [mode, sessionDispatch]);

  const play_mode_disclaimer_langs = [
    "eu_en", "de_de", "uk_en", "fr_fr", "it_it", "es_es", "at_de", "be_fr", "be_dt", "nl_de", "se_se", "nl_dt"
  ];
  //Settings.localKey

  let disclaimerKey;
  switch(drivingMode) {
    case DRIVING_MODE.PLAY:
    if (play_mode_disclaimer_langs.indexOf(Settings.localKey) >= 0) {
      disclaimerKey = "disclaimer_racing";
    }
    break;
    case DRIVING_MODE.GUIDE:
    break;
    
    case DRIVING_MODE.COMPLETED:
    case DRIVING_MODE.TRYAGAIN:
    disclaimerKey = "disclaimer_driving";
    break;

    case DRIVING_MODE.ZEROBACK:
    break;
    case DRIVING_MODE.ZEROBACK_COMPLETED:
    disclaimerKey = "disclaimer_default";
    break;
    case DRIVING_MODE.ZEROBACK_TRYAGAIN:
    disclaimerKey = "disclaimer_default";
    break;
    case DRIVING_MODE.MAX_SPEED:
    disclaimerKey = "disclaimer_260";
    break;

    default: 
    disclaimerKey = "disclaimer_default";
    break;
  }

  let showMuteButton = false;

  switch(drivingMode) {
    case DRIVING_MODE.PLAY:
    showMuteButton = !isTouch();
    break;
    
    case DRIVING_MODE.COMPLETED:
    case DRIVING_MODE.TRYAGAIN:
    case DRIVING_MODE.GTMODE_GUIDE:
    case DRIVING_MODE.ZEROBACK:
    case DRIVING_MODE.ZEROBACK_COMPLETED:
    case DRIVING_MODE.ZEROBACK_TRYAGAIN:
    case DRIVING_MODE.MAX_SPEED:
    showMuteButton = true;
    break;

    default: 
    
    break;
  }


  return (
    <React.Fragment>
      <main>
        {drivingMode === DRIVING_MODE.GUIDE && (
          <Guide onClose={() => setDrivingModeUrl(DRIVING_MODE.PLAY)} onOpenModalIndex={handleOpenModalIndex} onCloseModalIndex={handleCloseModalIndex} openModalIndex={openModalIndex || openModalExteriorColor} />
        )}
        {drivingMode === DRIVING_MODE.PLAY && countdown >= 0 && (
          <Countdown countdown={countdown} />
        )}
        {drivingMode >= DRIVING_MODE.COMPLETED && drivingMode <= DRIVING_MODE.TRYAGAIN && (
          <DrivingResult 
            completed={drivingMode === DRIVING_MODE.COMPLETED} 
            items={GTItemArray}
            ecoItemCount={ecoItemCount} 
            onRetry={handleRetry} 
            onEcoDisclaimer={()=>{setDisclaimerPopupKey("disclaimer_eco_popup") }}
            onNext={() => {
              window.tagManager.stepGamePlayResultUpgradeLinkClick();
              setDrivingModeUrl(DRIVING_MODE.GTMODE_GUIDE); 
            }}
            isHidden={openModalIndex || openModalExteriorColor} />
        )}
        {drivingMode >= DRIVING_MODE.ZEROBACK && drivingMode <= DRIVING_MODE.ZEROBACK_TRYAGAIN && (
          <DrivingZeroback
            completed={
              drivingMode === DRIVING_MODE.ZEROBACK_COMPLETED
                ? true
                : drivingMode === DRIVING_MODE.ZEROBACK_TRYAGAIN
                ? false
                : undefined
            }
            onStart={handleStartZeroback}
            onStop={handleStopZeroback}
            onRetry={handleRetryZeroback}
            imageCaptured={imageCaptured}
            showDisclaimer={setDisclaimerPopupKey}
            onNext={() => {
              window.tagManager.accelerationOfGTResultContinueLinkClick();
              setDrivingModeUrl(DRIVING_MODE.MAX_SPEED);

            }}
            
          />
        )}
        {drivingMode === DRIVING_MODE.MAX_SPEED && <MaxSpeed onNext={() => setDrivingModeUrl(DRIVING_MODE.MAP)} isHidden={openModalIndex} />}
        {drivingMode === DRIVING_MODE.MAP && <Map onNextA={() => setDrivingModeUrl(DRIVING_MODE.GUIDE)} onNextB={() => history.push('/driving-zone/course-b/intro')} isHidden={openModalIndex} />}
        {drivingMode === DRIVING_MODE.GTMODE_GUIDE && <GTModeGuide onNext={() => setDrivingModeUrl(DRIVING_MODE.ZEROBACK)}/>}
        <HeadsUpDisplay
          items={GTItemArray}
          ecoItemCount={ecoItemCount}
          isDriving={drivingMode === DRIVING_MODE.PLAY}
          isHidden={drivingMode === DRIVING_MODE.GUIDE || countdown >= 0 || openModalIndex || openModalExteriorColor}
          onOpenModalIndex={handleOpenModalIndex}
        />
      </main>
      <ModalIndex
        open={openModalIndex}
        onClose={handleCloseModalIndex}
        onOpenModalExteriorColor={showModalIndexColorButton || (drivingMode >= DRIVING_MODE.PLAY && drivingMode <= DRIVING_MODE.ZEROBACK_TRYAGAIN && drivingMode !== DRIVING_MODE.GTMODE_GUIDE) ? handleOpenModalExteriorColor : undefined}
      />
      <ModalExteriorColor
        open={openModalExteriorColor}
        onClose={handleCloseModalExteriorColor}
      />

      {showMuteButton && <SoundToggleButton />}
      {disclaimerPopupKey === "" && disclaimerKey != null && <Disclaimer textKey={disclaimerKey} />}

      { disclaimerPopupKey !== "" && 
      <Disclaimer popupTextKey={disclaimerPopupKey} onPopupClose={()=>{
        setDisclaimerPopupKey("");
      }} />
      }
      
      {drivingMode !== DRIVING_MODE.GUIDE && isLoading && (<Loading></Loading>) }

    </React.Fragment>
  );
}
